import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import { Container } from "react-bootstrap";
import { apiRequest } from "../services/apiService";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { API_URL } from "../config/api";

export default function List() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("getusers", "GET");

        if (Array.isArray(response)) {
          setOptions(response);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.log("Błąd pobierania danych:", error.message);
      }
    };
    fetchData();
  }, []);

  const groupedOptions = options.reduce((acc, item) => {
    const groupKey = item.voivodeship || "Inne";
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(item);
    return acc;
  }, {});

  const handleRowClick = (id) => {
    navigate(`/portfolio/${id}`);
  };

  return (
    <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh", pb: 5 }}>
      <VN userData={userData} />

      <Container style={{ marginTop: "40px", maxWidth: "850px" }}>
        <Typography
          variant="h4"
          sx={{
            marginBottom: 4,
            fontWeight: 800,
            color: "#1a237e",
            letterSpacing: "-0.5px",
          }}
        >
          Katalog Opiekunek
        </Typography>

        {Object.entries(groupedOptions).map(([groupName, items]) => (
          <Box key={groupName} sx={{ marginBottom: 5 }}>
            <Typography
              variant="overline"
              sx={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "primary.main",
                display: "block",
                marginBottom: 1,
                borderLeft: "4px solid",
                paddingLeft: 2,
              }}
            >
              {groupName}
            </Typography>

            {items.map((item) => {
              const photoUrl = `${API_URL}/get-user-photo/${item.id}`;
              const initials = item.fullname
                ? item.fullname
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                : "?";

              return (
                <Paper
                  key={item.id}
                  elevation={0}
                  onClick={() => handleRowClick(item.id)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px 24px",
                    marginBottom: 1.5,
                    cursor: "pointer",
                    borderRadius: "16px",
                    border: "1px solid #e0e0e0",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)",
                      boxShadow: "0px 10px 20px rgba(0,0,0,0.05)",
                      borderColor: "primary.light",
                      backgroundColor: "#fff",
                    },
                    "&:active": {
                      transform: "scale(0.99)",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <Avatar
                      src={photoUrl}
                      alt={item.fullname}
                      sx={{
                        width: 56,
                        height: 56,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        fontSize: "1.2rem",
                        bgcolor: "primary.main",
                        textTransform: "uppercase",
                      }}
                    >
                      {initials}
                    </Avatar>

                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "1.1rem",
                          fontWeight: 700,
                          textTransform: "capitalize",
                        }}
                      >
                        {item.fullname}
                      </Typography>

                      <Box sx={{ display: "flex", gap: 2, mt: 0.5 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: "text.secondary",
                          }}
                        >
                          <PhoneIcon sx={{ fontSize: 16, mr: 0.5 }} />
                          <Typography variant="caption">
                            {item.phone}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: "text.secondary",
                          }}
                        >
                          <LocationOnIcon sx={{ fontSize: 16, mr: 0.5 }} />
                          <Typography variant="caption">
                            Miejscowość: {item.city}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ textAlign: "right" }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.disabled",
                        fontWeight: "bold",
                        display: "block",
                      }}
                    >
                      ID: #{item.id}
                    </Typography>
                  </Box>
                </Paper>
              );
            })}
          </Box>
        ))}
      </Container>
    </Box>
  );
}
